import { apiRequest } from './api'

export function signIn(companyCode, login, password) {
  return apiRequest('/auth/signin', {
    method: 'POST',
    skipAuth: true,
    body: JSON.stringify({ companyCode, login, password }),
  })
}

export function signOut() {
  return apiRequest('/auth/signout', {
    method: 'POST',
  })
}
